import { Lot } from 'types';

/**
 * Calculates the maximum sequential number (SNO) from a collection of lots
 *
 * @param existingLots {Lot[]} - Array of lots to extract SNO values from
 * @returns {Number} The maximum SNO value found in the existing lots, or 0 if no valid SNOs exist
 *          (returns 0 for empty/null/undefined inputs or when all SNOs are negative)
 */
export const calculateNextLotSno = (existingLots: Lot[] = []): number => {
  if (!existingLots || !Array.isArray(existingLots)) {
    return 0;
  }

  const existingSNos = existingLots
    .filter(Boolean)
    .map(lot => lot.sno ?? 0);

  return existingSNos.length === 0 ? 0 : Math.max(0, ...existingSNos);
};
